import { render, staticRenderFns } from "./Reject.vue?vue&type=template&id=38ae101c&"
import script from "./Reject.vue?vue&type=script&lang=js&"
export * from "./Reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports